<!-- WORKING: Named Driver -->

<nx-accordion variant="light">
  <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
    <nx-expansion-panel-header>
      <nx-expansion-panel-title class="accordion_edit">
        Coverage
      </nx-expansion-panel-title>
    </nx-expansion-panel-header>

    <div nxLayout="grid nopadding">

      <form [formGroup]="driverNameForm">
        <div nxLayout="grid nopadding" class="coverage_endorsement">
          <div nxRow>
            <div nxCol="12" class="driver_list">
              <div>
                <app-external-scrollbar targetSyncScroll="2" [targetBaseWidth]="tableHolder2"></app-external-scrollbar>
                <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder2 syncScroll="2">
                  <table nxTable zebra class="named_driver_table" aria-label="namedDriverTableDesc">
                    <thead>
                      <tr nxTableRow>
                        <th nxHeaderCell></th>
                        <th nxHeaderCell>Driver Name</th>
                        <th nxHeaderCell>Driver ID</th>
                        <th nxHeaderCell colspan="2">Driver Age</th>
                      </tr>
                    </thead>
                    <tbody formArrayName="rows">
                      @for (row of rows.controls; track row) {
                      <tr nxTableRow [formGroupName]="$index">
                        <td nxTableCell>{{ $index + 1 }}</td>
                        <td nxTableCell>
                          <nx-formfield appearance="outline">
                            <input formControlName="driverName" maxlength="100" nxInput appToUpperCase />
                          </nx-formfield>
                        </td>
                        <td nxTableCell>
                          <nx-formfield appearance="outline" class="driver_id">
                            <input formControlName="driverId" maxlength="20" (change)="onChangeDriverId($index)" nxInput
                              appToUpperCase appAlphaNumeric />
                          </nx-formfield>
                        </td>
                        <td nxTableCell>
                          <nx-formfield appearance="outline" class="driver_age">
                            <input formControlName="driverAge" maxlength="3" nxInput [appOnlyNumber]="true" />
                          </nx-formfield>
                        </td>
                        @if ($index !== 0) {
                        <td nxTableCell>
                          <button nxPlainButton type="button" class="nx-margin-left-m" (click)="deleteDriver($index)">
                            <nx-icon name="trash-o" size="s"></nx-icon>
                          </button>
                        </td>
                        }
                      </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div nxRow class="nx-margin-top-m nx-margin-bottom-m">
          <div nxCol="12">
            <button nxPlainButton type="button" class="nx-margin-right-m" (click)="addDriver()"
              [disabled]="isDisableAddDriverBtn"><nx-icon name="plus" nxIconPositionStart aria-hidden="true"></nx-icon>ADD
              DRIVER</button>
          </div>
        </div>

        @if(showEHailingComponent){
        <div nxRow>
          <div nxCol="12">
            <app-e-hailing-driver [parentForm]="driverNameForm"></app-e-hailing-driver>
          </div>
        </div>
        }

      </form>

    </div>
  </nx-expansion-panel>
</nx-accordion>

<ng-template #warningPopup let-popup_message="popup_message">
  <div class="std-ta-center">
    <div nxModalContent>
      <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">
        Warning
      </h3>
      <p nxCopytext="normal" class="nx-modal-margin-bottom nx-font-weight-light">
        Kindly make changes to proceed for endorsement.
      </p>
    </div>

    <button nxModalClose nxButton="primary" type="button">
      OK
    </button>
  </div>
</ng-template>